import React, { lazy, Suspense } from 'react';

import {v4 as uuidv4} from 'uuid';
import {  cleanContextualOptions, setContextualOptions } from '../../../auto/js/widgets';

import '@trendmicro/react-breadcrumbs/dist/react-breadcrumbs.css';
import '@trendmicro/react-buttons/dist/react-buttons.css';
import '@trendmicro/react-dropdown/dist/react-dropdown.css';
import 'bootstrap/dist/css/bootstrap.css';
import "bootstrap/dist/css/bootstrap.min.css";

import { Talifoon } from '../../../auto/js/events/Talifoon';
import { SidePanelComponent } from '../widgets/SidePanelComponent';
import { Observable } from '../events/Observable';
import { t } from '../services';

const DraggableModalBrowser = lazy(() => import('./DraggableModalBrowser')); // Lazy load to avoid circular dependency


const welcomeUUID = uuidv4();

export const createBrowserComponent = () => class Browser extends React.Component {
	constructor(props) {
		super(props)
		this.history = null;
		this.size = 0;
        this.limit = 100;
        this.views = new Map();
		this.requestingClose = false;
		this.openSidePanelEvent = new Observable();
		this.clodeSidePanelEvent = new Observable();
		this.openModalEvent = new Observable();
		this.closeModalEvent = new Observable();
		this.welcome = {uuid: welcomeUUID, view: ()=>props.welcome(welcomeUUID)}
		this.register(this.welcome);
		this.state = {
			focusedView: this.welcome
		};
		this.canISwitch = new Talifoon();
    }

	readWelcomePage = () => {
		return this.welcome;
	}

	register = (v) => {
		this.views.set(v.uuid, v);
	}
	
	unregister = (v) => {
		if (v.getContext)
			cleanContextualOptions(v.getContext());
		this.views.delete(v.uuid);
	}

	canISwitchTo = (v) => {
		if (this.state.focusedView) {
			this.requestingClose = true;
			this.canISwitch.send(this.doSwitchTo(v), () => this.doSwitchTo(v)(true));
		}
	}

	doSwitchTo = (v) => (closeCurrent) => {
		if (closeCurrent) {
			this.switchView(v);
		}
		this.requestingClose = false;
	}

	addToHistory = (data) => {
		// Adding data to the linked list history
		if (!this.history) {
		  this.history = { data, next: null };
		  this.size = 1;
		} else {
		  if (this.size === this.limit) {
			// Remove the oldest entry
			let current = this.history;
			this.history = current.next;
			this.size--;
		  }
		  let current = this.history;
		  while (current.next) {
			current = current.next;
		  }
		  current.next = { data, next: null };
		  this.size++;
		}
	}

	getHistoryBeforeLast = () => {
        // Retrieve the entry just before the last entry in the history
        if (!this.history || !this.history.next) {
          return null; // If there are 0 or 1 entries in history
        }
        let current = this.history;
        while (current.next && current.next.next) {
          current = current.next;
        }
        return current.data;
      }

	goTo = (cmd, args, windowId) => {
        let v = cmd(args);
        this.addToHistory({cmd, args, windowId});
        if (!this.requestingClose)
			this.canISwitchTo(v)
    }

	openSidePanel = (body, title, getContext) => {
		this.openSidePanelEvent.publish({body: body, title: title, getContext: getContext})
	}
	
	openModal = (body, title, callback, getContext) => {
		this.openModalEvent.publish({body: body, title: title, callback: callback, getContext: getContext})
	}
	
	closeModal = () => {
		this.closeModalEvent.publish();
	}

	closeSidePanel = () => {
		this.clodeSidePanelEvent.publish();
	}

	switchView = function (v) {
		// default behavior for now is one view at a time
		// this will eventually change though
		if (this.state.focusedView) {
			if (this.state.focusedView.uuid==v.uuid)
				return;
			else {
				this.unregister(this.state.focusedView);
				this.canISwitch.hangUp();
			}
		}
		if (!this.views.has(v.uuid)) {

			this.register(v);
		}
		if(v.getContext)
			setContextualOptions(v.getContext());
		this.setState({focusedView:v});
		this.requestingClose = false;
	}
	
	buildDesktop = () => {
		let Desktop;
		for (const [uuid, v] of this.views.entries()) {
			Desktop = <>{v.view()}
			<SidePanelComponent openEvent={this.openSidePanelEvent} closeEvent={this.clodeSidePanelEvent} />
			<Suspense fallback={<div>{t`Loading`}...</div>}>
			<DraggableModalBrowser openEvent={this.openModalEvent} closeEvent={this.closeModalEvent} />
			</Suspense>
			</>
		}
		return Desktop;
	}
	
}